<template>
  <!--去看看单个商品组件（纵向排序）-->
  <tk-flex
    style="position: relative;"
    @click.native="$push({ path: '/commodity/productDetails', query: { id: commodity.objectId } })"
    class="full-width"
  >
    <div class="commodity-look-image">
      <div
        class="class-recommended-img"
        :style="{ width: imageWidth + 'px' }"
      >
        <tk-image
          class="img-radius class-recommended-image"
          :src="commodity.showPictures[0]"
          :width="imageWidth" :height="imageHeight"></tk-image>
      </div>
      <div v-if="listIndex >= 0">
        <div class="class-hot-list" slot="tips" v-if="listIndex === 0 || listIndex === 1 || listIndex === 2" :style="{backgroundImage: `url(${commodity.tipsImage}) !important`}">
          <div>TOP</div>
          <div>{{listIndex + 1}}</div>
        </div>
        <div v-else class="class-round-tips font-14">{{listIndex + 1}}</div>
      </div>
    </div>
    <tk-flex
      column
      style="position: relative;align-self: stretch;"
      class="van-flex-row m-l-15 p-t-5">
      <tk-flex
        middle
        class="full-width"
      >
        <div
          style="width: 35px;flex-shrink:0;"
        >
          <tk-flex
            center
            v-if="commodity.selfAndSelected"
            style="line-height: 17px;"
            class="commodity-title-label">
            <div>
              {{commodity.selfAndSelected | titleLabel}}
            </div>
          </tk-flex>
        </div>
        <div class="font-14 van-ellipsis">{{commodity.productTitle}}</div>
      </tk-flex>
      <div
        class="class-card-selling class-card-ellipsis m-t-4"
        :style="{color: sellingColor,
         padding: ((commodity.selling ? sellingBg : 'rgba(255, 255, 255, 0)')
          === 'rgba(255, 255, 255, 0)') ? '3px 0 !important' : '3px',
         background: commodity.selling ? sellingBg : 'rgba(255, 255, 255, 0)'}"
      >
        {{commodity.selling}}
      </div>
      <slot name="sales"></slot>
      <tk-flex
        between
        bottom
        style="position: absolute;bottom: 5px;"
        :class="{ 'p-r-5': lookType === 'promotions' }"
        class="full-width"
      >
        <div>
          <div
            v-if="commodity.oldPrice"
            class="class-card-red"
          >
            <span class="font-10">￥</span>
            <span>{{commodity.price}}</span>
            <span class="font-12 m-l-5 class-card-decoration caption"><span class="font-10">￥</span>{{commodity.oldPrice}}</span>
          </div>
          <div
            v-else
            class="class-card-red"
          >
            <span class="font-10">￥</span>{{commodity.price}}
          </div>
        </div>
        <tkui-button
          :class="{'raised': isRaised, 'border': isBorder, 'rounded': isRounded}"
          class="small primary class-card-look"
          :style="{backgroundColor: bgColor}"
        >
          {{btnText}}
        </tkui-button>
      </tk-flex>
    </tk-flex>
    <slot name="tips"></slot>
  </tk-flex>
</template>

<script>
export default {
  props: {
    commodity: {
      type: Object
    },
    sellingColor: {
      type: String
    },
    sellingBg: {
      type: String
    },
    isShowSelling: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '去看看'
    },
    isRaised: {
      type: Boolean,
      default: true
    },
    isBorder: {
      type: Boolean,
      default: true
    },
    isRounded: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String,
      default: ''
    },
    listIndex: {
      type: Number,
      default: -1
    },
    imageWidth: {
      type: Number,
      default: 108
    },
    imageHeight: {
      type: Number,
      default: 108
    },
    lookType: {
      type: String,
      default: 'String'
    }
  },
  filters: {
    titleLabel (val) {
      return val === 'self' ? '自营' : '精选'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .class-card-red { /*颜色及文本修饰*/
    color: rgba(250, 51, 51, 1);
  }
  /*图片样式*/
  .commodity-look-image {
    border-radius: 5px;
    position: relative;
    font-size: 0;
    /*提示样式*/
    .class-hot-list {
      text-align: center;
      background-position: center center;
      background-repeat:  no-repeat;
      background-size: 100% 100%;
      position: absolute;
      min-width: 27px;
      min-height: 34px;
      padding: 2px;
      font-size: 10px;
      color: #fff;
      border-radius: 5px;
      overflow: hidden;
      top: 0;
      left: 0;
    }
    .class-round-tips {
      position: absolute;
      width: 22px;
      height: 22px;
      color: #fff;
      line-height: 22px;
      text-align: center;
      border-radius: 50%;
      background:linear-gradient(0deg,rgba(204,204,206,1),rgba(219,217,213,1));
      overflow: hidden;
      top: 0;
      left: 0;
    }
  }
  /*卖点样式*/
  .class-card-selling {
    width: 100%;
    min-height: 18px;
    border-radius: 2px;
    font-size: 12px;
  }
  /*去看看按钮样式*/
  .class-card-look {
    min-width: 60px;
    margin: 0;
    height: 26px;
    line-height: 26px !important;
  }
  .class-card-rect {
    width: 65px;
    height: 24px;
    border: 1px solid rgba(242, 90, 52, 1);
    border-radius: 5px;
  }
</style>
